<script>
import ElPagination from 'element-ui/lib/pagination'

export default {
  name: 'ElPagination',
  extends: ElPagination,
  components: {
    Sizes: {
      extends: ElPagination.components.Sizes,
      render (h) {
        const vnode = ElPagination.components.Sizes.render.call(this, h)
        const select = vnode.children.find(child => child.componentOptions)
        if (select) {
          const props = select.componentOptions.propsData
          props.popperClass = ['terminal-dropdown-menu ui-select-dropdown ui-pagination-popper', props.popperClass].filter(Boolean).join(' ')
        }
        return vnode
      }
    }
  },
  render (h) {
    const vnode = ElPagination.render.call(this, h)
    if (!vnode) return vnode
    vnode.data = vnode.data || {}
    vnode.data.class = [vnode.data.class, 'ui-pagination']
    return vnode
  }
}
</script>
